import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UserDetail, UserInfo } from '@ca/core/models';
import { UserService } from '@ca/core/services';
import { BehaviorSubject, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Component({
    selector: 'ca-shared-with',
    templateUrl: './shared-with.component.html',
    styleUrls: ['./shared-with.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SharedWithComponent {
    @Input() sharedWithUsers: UserDetail[];
    @Input() set ownerId(ownerId: string) {
        this._ownerId = ownerId;
        this.isUserOwner = this.userService.isOwner(ownerId);
        this.loadMyProfileInfoAction$$.next(ownerId);
    }
    get ownerId(): string {
        return this._ownerId;
    }

    ownerInfo$: Observable<UserInfo>;
    isUserOwner: boolean;

    private _ownerId: string;
    private loadMyProfileInfoAction$$ = new BehaviorSubject('');

    constructor(private userService: UserService) {
        this.ownerInfo$ = this.loadMyProfileInfoAction$$.asObservable().pipe(switchMap((userId: string) => this.userService.getMyProfileInfo$(userId)));
    }
}
